(function () {
  function packageCount(value) {
    const text = String(value || '');
    const match = text.match(/\bcase\s+(?:pack\s+)?(?:of\s*)?(\d+)\b/i) ||
      text.match(/\bpack\s+of\s*(\d+)\b/i) ||
      text.match(/\b(\d+)\s*[- ]?\s*(?:pack|count|ct)\b/i) ||
      text.match(/^\s*(\d+)\s*\/\s*\d+(?:\.\d+)?\s*[-–]?\s*(?:ounces?|oz)\b/i) ||
      text.match(/\b(\d+)\s*[x×]\s*\d+(?:\.\d+)?\s*(?:ounces?|oz)\b/i);
    return match ? Number(match[1]) : 0;
  }

  function concisePackage(value) {
    const text = String(value || '').trim();
    if (/\b(?:up to|above|under|over)\s+\d/i.test(text) || /\b\d+(?:\.\d+)?\s*(?:–|to|-)\s*\d+(?:\.\d+)?\s*(?:lbs?|pounds?|ounces?|oz|kg|g)\b/i.test(text)) return text;
    const weights = Array.from(text.matchAll(/(?:\b|[x×])(\d+(?:\.\d+)?)\s*[-–]?\s*(lbs?|pounds?|ounces?|oz|kilograms?|kg|grams?|g|ml|liters?|litres?|l)\b/gi));
    const count = text.match(/\b(\d+)\s*[- ]?\s*(?:count|ct)\b/i) || text.match(/^\s*(\d+)\s*\/\s*\d+(?:\.\d+)?\s*(?:ounces?|oz)\b/i) || text.match(/\b(\d+)\s*[x×]\s*\d+(?:\.\d+)?\s*(?:ounces?|oz)\b/i);
    if (weights.length !== 1) return weights.length === 0 && count ? count[1] + '-count' : text;
    const unit = weights[0][2].toLowerCase();
    const normalized = /^(lb|lbs|pound)/.test(unit) ? 'lb' : /^(oz|ounce)/.test(unit) ? 'oz' : /^(kg|kilogram)/.test(unit) ? 'kg' : /^(g|grams?)$/.test(unit) ? 'g' : /^(l|liter|litre)/.test(unit) ? 'L' : unit;
    const size = weights[0][1] + '-' + normalized;
    const caseCount = text.match(/\bcase\s+(?:pack\s+)?(?:of\s*)?(\d+)\b/i);
    const packCount = text.match(/\bpack\s+of\s+(\d+)\b/i) || text.match(/\b(\d+)\s*[- ]\s*pack\b/i);
    if (caseCount) return size + ' · Case of ' + caseCount[1];
    if (packCount) return size + ' · Pack of ' + packCount[1];
    if (count) return size + ' · ' + count[1] + '-count';
    if (/\beach\b/i.test(text)) return size + ' · Each';
    return size;
  }

  function packageLabel(value, unitKind) {
    const compact = concisePackage(value);
    const count = packageCount(value);
    if (unitKind === 'wet' && count > 0 && /^\d+(?:\.\d+)?-(?:oz|lb|kg|g|ml|L)(?: · .*)?$/.test(compact)) {
      return compact.split(' · ')[0] + ' · Case of ' + count;
    }
    return compact;
  }

  function conciseOptions(purchase, unitKind) {
    purchase.querySelectorAll('select[data-product-option]').forEach(select => {
      const options = Array.from(select.options);
      const labels = options.map(option => packageLabel(option.value, unitKind));
      options.forEach((option, index) => {
        if (labels.filter(label => label === labels[index]).length === 1) option.textContent = labels[index];
      });
    });
    purchase.querySelectorAll('input[data-product-option]').forEach(input => {
      const label = input.closest('label');
      const name = label && label.querySelector('.option-value-name');
      const values = Array.from(purchase.querySelectorAll('input[data-product-option]')).filter(other => other.name === input.name).map(other => other.value);
      const compact = packageLabel(input.value, unitKind);
      if (name && values.filter(value => packageLabel(value, unitKind) === compact).length === 1) name.textContent = compact;
    });
  }

  function init(scope) {
    const section = scope.querySelector('.product--section') || (scope.matches && scope.matches('.product--section') ? scope : null);
    if (!section || section.dataset.azProductReady) return;
    const source = section.querySelector('[data-section-data]');
    const purchase = section.querySelector('[data-product-form-area]');
    const labelSource = purchase && purchase.querySelector('[data-az-product-labels]');
    if (!source || !purchase || !labelSource) return;
    let product, labels, sectionData;
    try { sectionData = JSON.parse(source.textContent); product = sectionData.product; labels = JSON.parse(labelSource.textContent); } catch (_) { return; }
    if (!product) return;
    section.dataset.azProductReady = 'true';
    const unitInfo = purchase.querySelector('[data-az-unit-kind]');
    const unitKind = unitInfo && unitInfo.dataset.azUnitKind;
    conciseOptions(purchase, unitKind);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
    });
    function selectedVariant() {
      const selectors = Array.from(purchase.querySelectorAll('select[data-product-option]'));
      const radios = Array.from(purchase.querySelectorAll('input[data-product-option]:checked'));
      const selected = selectors.length ? selectors.map(s => s.value) : radios.map(s => s.value);
      if (selected.length) {
        const match = product.variants.find(v => v.options.every((value, index) => value === selected[index]));
        if (match) return match;
      }
      const idInput = purchase.querySelector('[name="id"]');
      const id = idInput && idInput.value;
      return product.variants.find(v => String(v.id) === String(id)) ||
        product.variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant')) ||
        product.variants.find(v => v.available) || product.variants[0];
    }
    function displayPackage(value, index) {
      const values = Array.from(new Set(product.variants.map(variant => variant.options[index])));
      const compact = packageLabel(value, unitKind);
      return values.filter(option => packageLabel(option, unitKind) === compact).length > 1 ? value : compact;
    }
    function updateUnit() {
      if (!unitInfo) return;
      const variant = selectedVariant();
      if (!variant) return;
      const defaultVariant = variant.title === 'Default Title';
      const packageText = defaultVariant ? product.title : variant.title;
      const explicitCase = packageText.match(/\bcase\s+(?:pack\s+)?(?:of\s*)?(\d+)\b/i);
      const count = unitKind === 'wet' ? packageCount(packageText) : explicitCase ? Number(explicitCase[1]) : 0;
      let title = labels.packageTitle, note = labels.packageNote;
      let detail = defaultVariant ? '' : variant.options.map(displayPackage).join(' / ');
      if (unitKind !== 'pack' && !count && /\beach\b/i.test(packageText) && !/\bpack\s+of\b/i.test(packageText)) {
        title = labels.eachTitle; note = labels.eachNote;
      } else if (unitKind === 'bag' && !/\bcase\b|\bpack\s+of\s+\d+/i.test(packageText)) {
        title = labels.bagTitle; note = labels.bagNote;
      } else if ((unitKind === 'wet' || explicitCase) && count > 0) {
        title = labels.caseTitle; note = labels.caseNote;
        const can = /canned|\bcans\b/i.test(product.title + ' ' + (product.type || ''));
        detail = (defaultVariant ? labels.caseCount.replace('__COUNT__', String(count)) : variant.options.map(displayPackage).join(' / ')) +
          ' · ' + money.format(variant.price / 100 / count) + ' ' + (can ? labels.perCan : labels.perItem);
      } else if (unitKind === 'pack') {
        title = labels.packTitle; note = labels.packNote;
      }
      unitInfo.querySelector('[data-az-unit-label]').textContent = title;
      unitInfo.querySelector('[data-az-unit-detail]').textContent = detail;
      unitInfo.querySelector('[data-az-unit-note]').textContent = note;
    }
    function updateVariantImage() {
      const variant = selectedVariant();
      if (!variant) return;
      const zoom = section.querySelector('a.MagicZoomPlus, a.MagicZoom');
      const api = window.MagicZoom || window.MagicZoomPlus;
      if (!zoom || !api) return;
      const file = url => String(url || '').split('/').pop().split('?')[0];
      const featured = variant.featured_image || product.featured_image;
      const image = typeof featured === 'string' ? featured : featured && (featured.src || featured.url);
      if (!image) return;
      const thumbnail = Array.from(section.querySelectorAll('a[data-zoom-id]')).find(link => link.dataset.zoomId === zoom.id && file(link.href) === file(image));
      if (!thumbnail) return;
      try {
        if (typeof api.switchTo === 'function') api.switchTo(zoom.id, thumbnail);
        else if (typeof api.update === 'function') api.update(zoom.id, thumbnail.href, thumbnail.dataset.image || thumbnail.href);
        else return;
      } catch (_) {}
    }
    function syncPurchase() {
      const variant = selectedVariant();
      if (!variant) return;
      const formatPrice = cents => window.Shopify && typeof window.Shopify.formatMoney === 'function'
        ? window.Shopify.formatMoney(cents || 0, sectionData.settings.money_format).replace(/<[^>]*>/g, '')
        : money.format((cents || 0) / 100);
      const details = section.querySelector('[data-product-details]');
      const price = details && details.querySelector('[data-price] .money');
      if (price) price.textContent = formatPrice(variant.price);
      const idInput = purchase.querySelector('[name="id"]');
      if (idInput) idInput.value = String(variant.id);
      const onSale = !!variant.compare_at_price && variant.compare_at_price > variant.price;
      const compare = details && details.querySelector('[data-price-compare-at]');
      if (compare) {
        compare.classList.toggle('visible', onSale);
        const amount = compare.querySelector('.money');
        if (amount) amount.textContent = formatPrice(variant.compare_at_price);
      }
      const badge = details && details.querySelector('[data-badge-sales]');
      if (badge) {
        badge.style.display = onSale ? '' : 'none';
        const saved = badge.querySelector('[data-price-money-saved]');
        const percent = badge.querySelector('[data-price-percent-saved]');
        if (saved) saved.textContent = formatPrice(onSale ? variant.compare_at_price - variant.price : 0);
        if (percent) percent.textContent = onSale ? String(Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)) : '0';
      }
      const button = purchase.querySelector('[data-product-atc]');
      if (button && !button.classList.contains('processing')) {
        button.disabled = !variant.available;
        button.classList.toggle('disabled', !variant.available);
        const context = sectionData.context || {};
        const text = variant.available ? context.product_available : context.product_unavailable;
        if (text) {
          const label = button.querySelector('.atc-button--text');
          if (label) label.textContent = text;
          else button.textContent = text;
        }
      }
    }
    function updateSelection() {
      syncPurchase();
      updateUnit();
      updateVariantImage();
    }
    purchase.addEventListener('change', function (event) {
      updateUnit();
      if (event.target.matches('[data-product-option], [name="id"]')) {
        syncPurchase();
        updateVariantImage();
        if (window.requestAnimationFrame) window.requestAnimationFrame(updateSelection);
      }
    });
    updateSelection();
    window.addEventListener('load', updateVariantImage, { once: true });
    if (unitKind === 'wet') {
      purchase.querySelectorAll('.form-field-title, .option-name').forEach(function (label) {
        if (label.textContent.trim().toLowerCase() === 'title') label.textContent = labels.caseOption;
      });
    }
    const description = section.querySelector('[data-az-description]');
    if (!description) return;
    const headings = Array.from(description.children).filter(el => /^H[2-6]$/.test(el.tagName));
    headings.forEach(heading => {
      const normalized = heading.textContent.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/^[^\p{L}\p{N}]+/u, '').trim().replace(/:$/, '').toLowerCase();
      if (!/^(complete ingredients|ingredients|guaranteed analysis|feeding guidelines|feeding & serving|feeding instructions|additional information|calorie content|caloric content|case details|package sizes and selling units|package information)$/.test(normalized)) return;
      const details = document.createElement('details');
      details.className = 'az-product-details';
      const summary = document.createElement('summary');
      const content = document.createElement('div');
      content.className = 'az-product-details-content';
      const nodes = [];
      let next = heading.nextSibling;
      while (next && !(next.nodeType === 1 && /^H[1-6]$/.test(next.tagName))) { nodes.push(next); next = next.nextSibling; }
      heading.replaceWith(details);
      summary.appendChild(heading);
      details.append(summary, content);
      nodes.forEach(node => content.appendChild(node));
    });
    description.querySelectorAll('table').forEach(table => {
      if (table.parentElement.classList.contains('az-table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'az-table-scroll';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', labels.tableLabel);
      table.replaceWith(wrapper);
      wrapper.appendChild(table);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();



